import { useForm } from "react-hook-form";

export type AssignFormValues = {
  application_type: "universal" | "cgs";
  assigned_at: string;
  ended_at: string;
  is_active: boolean;
  notes: string;
};

const DEFAULTS: AssignFormValues = {
  application_type: "universal",
  assigned_at: "",
  ended_at: "",
  is_active: true,
  notes: "",
};

export function useAssignForm() {
  return useForm<AssignFormValues>({ defaultValues: DEFAULTS });
}
